import React from 'react';

const Blogs = () => {
     return (
          <>
               <h1>This is Blogs</h1>
          </>
     );
};

export default Blogs;